import React, { useEffect, useState } from "react";
import { Spinner } from "./../spinner/Spinner";
import axios from "axios";
import { serverUrl } from "./../../utils/config";
import { Dropdown } from "../dropdown/Dropdown";
import { Modal } from "./../modal/Modal";

export const AddPost = (props) => {

  const { isLoading, setIsLoading, page, setPage, setPostSelected } = props;
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [headerTitle, setHeaderTitle] = useState("Seleziona");
  const [viewImage, setViewImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [categoria, setCategoria] = useState("");
  const [file, setFile] = useState(null);
  const [titolo, setTitolo] = useState("");
  const [descrizione, setDescrizione] = useState("");
  const [viewModal, setViewModal] = useState(false);
  const [messageModal, setMessageModal] = useState("");

  useEffect(() => {
    axios.post(`${serverUrl()}/cms/categories.php`)
      .then((response) => {
        if (response.data.status === "success") {
          setCategories(response.data.data);
        } else {
          console.log(response.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    getPost();
  }, []);

  const getPost = () => {
    axios.post(`${serverUrl()}/cms/posts.php`)
    .then((response) => {
      if (response.data.status === "success") {
        setPosts(response.data.data);
      } else {
        console.log(response.data.message);
      }
    })
    .catch((error) => {
      console.error(error);
    });
  };


  const addImage = (element) => {
    let file = element, src = (window.URL || window.webkitURL).createObjectURL(file);
    setFile(element);
    setViewImage(true);
    setSelectedImage(src);
    console.log(element);
  };

  const removeImage = () => {
    setViewImage(false);
    setSelectedImage("");
    document.getElementById('file').value = "";
    document.getElementById('file').focus();
  };

  const validateForm = () => {
    return (
      (selectedImage !== "" ? 1 : 0) +
      (categoria !== "" ? 1 : 0) +
      (titolo !== "" ? 1 : 0) +
      (descrizione !== "" ? 1 : 0)
    );
  };

  const resetFields = () => {
    removeImage();
    setTitolo("");
    setDescrizione("");
    setCategoria("");
    setHeaderTitle("Seleziona");
    document.getElementById('titolo').value = "";
  };

  const submit = () => {
    if (validateForm() >= 4) {
      const data = new FormData();
      data.append('idPost', makeid(8).toUpperCase());
      data.append('file', file);
      data.append('titolo', titolo);
      data.append('descrizione', descrizione);
      data.append('categoria', categoria);
      console.log(data);
      axios.post(`${serverUrl()}/cms/add_post.php`, data)
      .then((response) => {
        if (response.data.status === "success") {
          console.log("add product: ", response.data.data);
          resetFields();
          setMessageModal("Post inserito correttamente");
          setViewModal(true);
          getPost();
        } else {
          console.log(response.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
      });
    }else{
      alert(`Tutti i campi sono obbligatori`);
    }
  };

  const makeid = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  };

  return (
    <>
      <div className="cms-post">
        <div className="cms-fieldContainer">
          <div className="cms-doubleRow">
            <div className="cms-imageContainer">
              {viewImage &&
                <button
                  type="button"
                  className="cms-remove-image"
                  onClick={() => {
                    removeImage();
                  }}
                >
                  <i className="icon-cancel-circled"></i>
                </button>
              }
              <input
                id="file"
                tabIndex={0}
                type="file"
                name="files[]"
                accept="image/*"
                onChange={(e) => {
                  addImage(e.target?.files?.[0]);
                }}
              />
              <span className="cms-label">
                Seleziona un immagine
                <i className="icon-picture"></i>
              </span>
              {viewImage &&
                <img className="cms-image-uploaded" src={selectedImage} alt="" />
              }
            </div>
            <div className="cms-fields">
              <div className="cms-field">
                <label htmlFor="categoria">Categoria</label>
                <Dropdown
                  id="categoria"
                  type="categories"
                  options={categories}
                  setFilterCategory={setCategoria}
                  headerTitle={headerTitle}
                  setHeaderTitle={setHeaderTitle}
                />
              </div>
              <div className="cms-field">
                <label htmlFor="titolo">Inserisci titolo</label>
                <input
                  id="titolo"
                  type="text"
                  autoComplete="off"
                  placeholder="Titolo prodotto"
                  onChange={(e) => {
                    setTitolo(e.target.value);
                  }}
                />
              </div>
              <div className="cms-field">
                <label htmlFor="descrizione">Inserisci descrizione</label>
                <input
                  id="descrizione"
                  type="text"
                  autoComplete="off"
                  placeholder="Descrizione prodotto"
                  onChange={(e) => {
                    setDescrizione(e.target.value);
                  }}
                />
              </div>
              <div className="cms-footerButtons">
                <button
                  type="button"
                  onClick={() => {
                    submit();
                  }}
                >
                  <i className="icon-floppy"></i>
                  Salva
                </button>
                <button
                  type="button"
                  onClick={() => {
                    resetFields();
                  }}
                >
                  <i className="icon-cancel-2"></i>
                  Cancella
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="cms-list-items">
          <div className="headerPost">
            <div className="idPost">ID Post</div>
            <div className="categoriaPost">Categoria</div>
            <div className="titoloPost">Titolo</div>
          </div>
          {posts && posts.length > 0 && posts.map((item, i) => {
            return (
              <div key={i} className="post">
                <div className="idPost">{item?.idPost}</div>
                <div className="categoriaPost">{item?.categoriaPost}</div>
                <div className="titoloPost">
                  <button
                    type="button"
                    onClick={() => { setPage('add-product'); setIsLoading(true); setPostSelected(item); }}
                  >
                    {item?.titoloPost.replace("${counter}", item?.counterProducts)}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Spinner isLoading={isLoading} setIsLoading={setIsLoading} />
      {viewModal &&
        <Modal
          title={`Conferma`}
          message={messageModal}
          setViewModal={setViewModal}
        />
      }
    </>
  );
};